import React from "react";
import T from "prop-types";
import { Check, FormInput } from "MODULES/shared/components/Forms";
import {
  CAAC,
  EASA,
  FAA,
  OTHER,
  OTHER_TAG_TYPE,
  TCCA,
  UK_CAA
} from "MODULES/inventories/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { properCase } from "LIB/formatters/text";

function TagTypes({
  faa: { input: faa },
  easa: { input: easa },
  uk_caa,
  caac: { input: caac },
  tcca: { input: tcca },
  other: { input: other },
  other_tag_type: { input: otherTagType },
  disabled = false,
  getFieldValue,
  setFieldValue,
  required = false
}) {
  // eslint-disable-next-line
  const ukCaaInput = uk_caa ? uk_caa.input : null;

  return [
    <div className="form-group" style={{ cursor: "pointer" }}>
      <label className="control-label" htmlFor="tag_type">
        Release Type {required && <sup className="small text-danger">*</sup>}
      </label>
      <div
        id="tag_type"
        className="btn-group btn-group-justified"
        data-toggle="buttons"
      >
        <Check
          input={faa}
          label={FAA.toUpperCase()}
          disabled={disabled}
          icon="fa-check-circle"
        />
        <Check
          input={easa}
          label={EASA.toUpperCase()}
          disabled={disabled}
          icon="fa-check-circle"
        />
        {ukCaaInput && (
          <Check
            input={ukCaaInput}
            label={UK_CAA.replace("_", " ").toUpperCase()}
            disabled={disabled}
            icon="fa-check-circle"
          />
        )}
        <Check
          input={tcca}
          label={TCCA.toUpperCase()}
          disabled={disabled}
          icon="fa-check-circle"
        />
        <Check
          input={caac}
          label={CAAC.toUpperCase()}
          disabled={disabled}
          icon="fa-check-circle"
        />
        <Check
          input={other}
          label={OTHER.toUpperCase()}
          disabled={disabled}
          onChange={val => {
            if (!val) setFieldValue(otherTagType.name)("");
          }}
          icon="fa-check-circle"
        />
      </div>
    </div>,
    !getFieldValue(other.name) ? null : (
      <FormRow>
        <Col md={5}>
          <Field
            component={FormInput}
            disabled={disabled}
            name={OTHER_TAG_TYPE}
            label={properCase(OTHER_TAG_TYPE)}
            maxLength={10}
            max={10}
          />
        </Col>
      </FormRow>
    )
  ];
}

export default withFieldAccessors(TagTypes);

TagTypes.propTypes = {
  caac: T.instanceOf(Object),
  easa: T.instanceOf(Object),
  uk_caa: T.instanceOf(Object),
  faa: T.instanceOf(Object),
  tcca: T.instanceOf(Object),
  other: T.instanceOf(Object),
  other_tag_type: T.instanceOf(Object),
  getFieldValue: T.func.isRequired,
  setFieldValue: T.func.isRequired,
  disabled: T.bool,
  required: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/EditInventory/TagTypes.jsx